<template>
  <div id="app" v-title data-title="69csgoskins-最好的饰品体验！">
    <router-view v-if="isRouterAlive" />
    <Loading></Loading>
  </div>
</template>

<script>
import Utils from "./assets/js/util.js";
import Loading from './components/Loading.vue'
import DevicePixelRatio from './utils/devicePixelRatio.js';
export default {
  components:{
    Loading
  },
  name: "App",
  provide() {
    return {
      reload: this.reload,
      userInfo: {},
    };
  },
  data() {
    return {
      isRouterAlive: true,
    };
  },
  created() {
    new DevicePixelRatio().init();
    var lastTouchEnd = 0;
    document.addEventListener(
      "touchend",
      function (event) {
        var now = new Date().getTime();
        if (now - lastTouchEnd <= 300) {
          event.preventDefault();
        }
        lastTouchEnd = now;
      },
      false
    );
    this.$store.commit("setMobile", this.isMobile());
    window.addEventListener("resize", () => {
      this.$store.commit("setMobile", this.isMobile());
    });
    var u = navigator.userAgent;
    var flag;
    var myFunction;
    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (isIOS) {
      document.body.addEventListener("focusin", () => {
        //软键盘弹起事件
        flag = true;
        clearTimeout(myFunction);
      });
      document.body.addEventListener("focusout", () => {
        //软键盘关闭事件
        flag = false;
        if (!flag) {
          myFunction = setTimeout(function () {
            window.scrollTo({
              top: 0,
              left: 0,
              behavior: "smooth",
            }); //重点  =======当键盘收起的时候让页面回到原始位置(这里的top可以根据你们个人的需求改变，并不一定要回到页面顶部)
          }, 1);
        } else {
          return;
        }
      });
    } else {
      return;
    }
  },
  mounted() {
    let _this = this;
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    _this.userInfo = userInfo;
    _this.getUserInfo();
    setInterval(() => {
      this.getUserInfo();
    }, 10000);
    Utils.$on("pid", function (pid) {
      _this.userInfo.id = pid;
      _this.getUserInfo();
    });
  },
  created() {
    this.$store.commit("setMobile", this.isMobile());
    window.addEventListener("resize", () => {
      this.$store.commit("setMobile", this.isMobile());
    });
  },
  methods: {
    isMobile() {
      let flag = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
      return flag;
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    getUserInfo() {
      let param = {};
      if (this.$store.state.token) {
        const expire_time = JSON.parse(localStorage.getItem("userInfo")).expire_time;
        this.$axios
          .post("/api/player/playerdata", this.$qs.stringify(param))
          .then((res) => {
            if (res.data.code == 1) {
              const { total_amount, state, masonry } = res.data.data;
              if (total_amount && state) {
                this.$store.commit("getMoney", masonry);
                Utils.$emit("money", total_amount);
                Utils.$emit("state", state);
                localStorage.setItem(
                  "userInfo",
                  JSON.stringify({
                    ...res.data.data,
                    expire_time,
                  })
                );
              }
            }
          });
      }
    },
  },
};
</script>

<style lang="less">
.messageStyle{
  z-index: 9999999 !important;
}
body {
}

// div:active {
//   background-color: transparent;
//   /* 设置点击时的背景色为透明 */
//   outline: none;
//   /* 取消点击时的默认外边框样式 */
// }

// /* 滚动条 */
// ::-webkit-scrollbar-thumb:horizontal {
// 	/*水平滚动条的样式*/
// 	width: 4px;
// 	background-color: #cccccc;
// }

// ::-webkit-scrollbar-track-piece {
// 	background-color: #fff;
// 	/*滚动条的背景颜色*/
// 	-webkit-border-radius: 0;
// 	/*滚动条的圆角宽度*/
// }

// ::-webkit-scrollbar {
// 	width: 10px;
// 	/*滚动条的宽度*/
// 	height: 8px;
// 	/*滚动条的高度*/
// }

// ::-webkit-scrollbar-thumb:vertical {
// 	/*垂直滚动条的样式*/
// 	height: 50px;
// 	background-color: #e9b10e;
// 	outline: 2px solid #fff;
// 	outline-offset: -2px;
// 	border: 2px solid #fff;
// }

// ::-webkit-scrollbar-thumb:hover {
// 	/*滚动条的hover样式*/
// 	height: 50px;
// 	background-color: #e9b10e;
// }

@import "./assets/css/media.less";

//改
div,
blockquote,
body,
html,
button,
dd,
dl,
dt,
fieldset,
form,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
input,
legend,
li,
ol,
p,
pre,
td,
textarea,
th,
ul {
  margin: 0;
  padding: 0;
}

ul li {
  list-style: none;
}

html,
body {
  // overflow: scroll; -webkit-overflow-scrolling: touch;
  background-color: #000000;
}

html,
body,
#app {
  //  height: 100%;
  height: calc(~"100vh - 0px");
  //  height: calc(~"100vh");
  font-family: "Microsoft YaHei";
  font-family: -apple-system !important;
  font-family: "-apple-system", "HelveticaNeue" !important; // iOS 8 compatible, credit: @MarcoBoschi
  /* 启用滚动回弹效果 */
  // overflow-y: auto;
  background-color: #161932;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

@font-face {
  font-family: "YouSheBiaoTiHei";
  src: url("./assets/family/YouSheBiaoTiHei.ttf") format("truetype");
}

body::-webkit-scrollbar {
  display: none;
}

img {
  pointer-events: none;
}

.clear {
  clear: both;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type="number"] {
  -moz-appearance: textfield;
}

html /deep/ .v-modal {
  top: 60px;
}

//邮箱弹框 样式修改
html /deep/ .el-message-box {
  background-color: #333542;
  border: none;

  .el-message-box__title {
    color: #c3c3e2;
  }
}

// ::-webkit-scrollbar-track {
// 	background-color: #1c2127;
// }

// ::-webkit-scrollbar {
// 	width: 10px;
// 	height: 10px;
// }
/* 滚动条整体样式 */
/* 设置滚动条的宽度和高度 */
::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}

/* 滚动条轨道样式 */
::-webkit-scrollbar-track {
  background-color: transparent;
}

/* 滚动条滑块样式 */
::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 5px;
  /* 弧度 */
}

/* 鼠标悬停在滚动条上方时的滑块样式 */
::-webkit-scrollbar-thumb:hover {
  background-color: rgba(255, 255, 255, 0.5);
}

/* 滚动条角落的空白区域样式 */
::-webkit-scrollbar-corner {
  background-color: transparent;
}

* {
  scrollbar-width: thin;
  /* Firefox */
  scrollbar-color: rgba(255, 255, 255, 0.3) transparent;
  /* Firefox */
}

@media screen and (max-width: 767px) {
  .el-message-box {
    width: 80% !important;
  }
}
</style>
